/**
 * The app's server routes outside a server (Console v2 §3.1): create one,
 * list yours, leave one, delete one you own. Paths come from `Routes`.
 */
import {
  Routes,
  type CreateGuildRequest,
  type CreateGuildResponse,
  type GetMyGuildsResponse,
  type Snowflake,
} from '@neosocial/protocol';
import { api } from '../lib/api';

export const serversApi = {
  /** 201 with the server; 403 GUILD_CREATION_DISABLED, 400 MAX_GUILDS, 429. */
  create: (b: CreateGuildRequest) => api.client.post<CreateGuildResponse>(Routes.guilds(), b),
  mine: () => api.client.get<GetMyGuildsResponse>(Routes.meGuilds()),
  /** 204; the owner gets "Transfer ownership first". */
  leave: (guildId: Snowflake) => api.client.delete<void>(Routes.meGuild(guildId)),
  /** 204; the owner only, with a step-up when they have two-step. */
  remove: (guildId: Snowflake) => api.client.delete<void>(Routes.guild(guildId)),
};
